import { Button } from "@/components/ui/Button";
import { useAuth } from "@/hooks/useAuth";
import { useBranding } from "@/hooks/useBranding";
import { cn } from "@/lib/utils";
import { ArrowRight } from "lucide-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const { isAuthenticated } = useAuth();
  const { branding } = useBranding();
  const navigate = useNavigate();

  const currentTheme = useSelector((state) => state.theme.theme); // assuming your slice is named 'theme'
  const isDark = currentTheme === "dark";

  const onHandleLogin = () => {
    navigate(isAuthenticated ? "/admin/dashboard" : "/login");
  };

  return (
    <div className="font-sans antialiased text-text-primary">
      <div
        className={cn(
          "min-h-[100svh] bg-cover bg-center bg-no-repeat flex items-center justify-center px-4 pt-24 pb-14 sm:px-6 sm:pt-28 sm:pb-20",
          isDark
            ? "bg-[url('/images/home_page_bg_dark.jpg')]"
            : "bg-[url('/images/home_page_bg_light.jpg')]"
        )}
      >
        {/* Main Hero Content */}
        <div className="w-full max-w-2xl text-center py-10 sm:py-14 md:py-16">
          {/* Heading */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-medium leading-tight">
            <span className="block">HIRE SMARTER,</span>
            <span className="block font-bold">not harder.</span>
          </h1>

          {/* Description */}
          <p className="max-w-xl mx-auto text-sm sm:text-base md:text-lg mt-4 sm:mt-6 text-text-secondary px-2">
            {`${branding?.displayName || "IMS People Possible AI"} automates your recruitment workflow, enabling your team to focus on what matters most.`}
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-6 sm:mt-10 w-full sm:w-auto justify-center">
            <Button
              onClick={() => navigate("/user/job-listing")}
              className="w-full sm:w-auto bg-sky-500 hover:bg-sky-400 text-text-base px-2 py-3 md:px-6 rounded-full flex items-center justify-center gap-2"
            >
              View Open Jobs
              <ArrowRight className="hidden md:block w-4 h-4" />
            </Button>

            <Button
              onClick={onHandleLogin}
              className="w-full sm:w-auto bg-white/10 hover:bg-white/20 text-text-base py-2 px-1 md:px-6 rounded-full backdrop-blur-md border border-white/10"
            >
             Sign in
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
